<template>
  <div
    :class="'dropDown-option ' + analyticsClass"
    role="button"
    tabindex="0"
    :aria-label="ariaLabelText"
    @click="handleOptionClick"
    v-on:copy="doNotCopyElementText"
    v-on:cut="doNotCopyElementText"
    v-on:keyup.enter="handleOptionClick"
    v-on:keydown.up="onKeyUp"
    v-on:keydown.down="onKeyDown"
    v-bind="dataAttributeFromProps"
  >
    <div class="option-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  // TODO: computed value to default to text if no value prop is added
  // emit value text from component
  props: {
    text: {
      type: String
    },
    value: {
      type: String
    },
    dropDownId: {
      type: String,
      default() {
        return "";
      }
    },
    optionData: {
      type: String,
      default() {
        return null;
      }
    },
    dataAttribute: {
      type: String
    },
    dataAttributeValue: {
      type: String
    },
    analyticsClass: {
      type: String
    },
    isManufacturerOption: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  methods: {
    handleOptionClick(event) {
      this.$emit("optionClicked", {
        value: this.valueWithDefault,
        dropDownId: this.dropDownId,
        optionData: this.optionData,
        event
      });
    },
    onKeyUp(e) {
      e.preventDefault();
      const previousOption = e.target.parentNode.previousElementSibling;

      if (previousOption) {
        previousOption.querySelector(".dropDown-option").focus();
      }
      // reached the top of the list and want to move to the input
      else {
        this.$nextTick(() => {
          // for the manufacture menu
          if (this.isManufacturerOption) {
            this.$parent.$refs.searchManufacturerInput.focus();
          }
          // for the model menu
          else {
            this.$parent.$refs.searchModelInput.focus();
          }
        });
      }
    },
    onKeyDown(e) {
      e.preventDefault();
      this.$nextTick(() => {
        const nextOption = e.target.parentNode.nextElementSibling;

        if (nextOption) {
          nextOption.querySelector(".dropDown-option").focus();
        }
      });
    },
    doNotCopyElementText(event) {
      event.preventDefault()
    }
  },
  computed: {
    errorIconSrc() {
      return "https://res.cloudinary.com/avd/image/upload/v1661964419/Icons/New%20Design%20Site%20Icons/error.svg";
    },
    valueWithDefault() {
      if (this.value) {
        return this.value;
      } else {
        return this.text;
      }
    },
    ariaLabelText() {
      return `Option ${this.valueWithDefault}`;
    },
    dataAttributeFromProps() {
      if (this.dataAttribute && this.dataAttributeValue) {
        return {
          [this.dataAttribute]: this.dataAttributeValue.toLowerCase()
        };
      } else {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropDown-option {
  display: block;
  min-width: 100%;
  background-color: unset;
  padding-bottom: 16px;
  padding-top: 6px;
  padding-left: 20px;
  &:hover {
    cursor: default;
  }
}
.option-text {
  color: $black85;
  @include hdg();
  @include body_small();

  @media (min-width: $media-min-width-desktop) {
    @include body_standard();
  }
}

.option-required-product {
  @include hdg();
  @include caption();
  display: flex;
  align-items: center;
  background-color: $warning-200;
  border: 1px solid $warning-600;
  height: 37px;
  width: 249px;
  padding-left: 6px;
}

.required-product-link {
  text-decoration: underline;
  color: $primary;
  &:hover,
  &:focus {
    color: $primary-300;
  }
}

.errorIcon {
  margin-right: 6px;
}
</style>
